import { DatepickerDayItemType } from "@website/ui/datepicker/datepicker.types";

type DiscountableDay = Pick<DatepickerDayItemType, "hasDiscount">;

export const hasDiscountInRow = (
  days: ReadonlyArray<DiscountableDay>,
  index: number
) => {
  const rowStart = Math.floor(index / 7) * 7;
  const rowEnd = rowStart + 7;

  return days.slice(rowStart, rowEnd).some(({ hasDiscount }) => hasDiscount);
};
